module.exports = __webpack_public_path__ + "083e14f813ab72542333e41f8fdb97e3.pdf";